<template>
    <div class="d-flex flex-row align-items-center my-n3">
        <div>
            <img :src="getMMO" alt="" class="img-fluid" style="max-height: 45px;">
        </div>
        <div class="d-flex flex-column ms-2">
            <img :src="getATP" class="mb-2" alt="" style="max-height: 12px;">
            <img :src="getWTA" alt="" style="max-height: 12px;">
        </div>
    </div>
</template>

<script>
import ATP from './../assets/atp.png'
import MMO from './../assets/mutua.png'
import WTA from './../assets/wta.png'

export default {
    name: "Logo",
    computed: {
        getATP() {
            return ATP;
        },
        getMMO() {
            return MMO;
        },
        getWTA() {
            return WTA;
        }
    }
}
</script>

<style scoped>

</style>
